var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: { title: _vm.title, visible: _vm.isShow, width: "500px" },
      on: {
        "update:visible": function ($event) {
          _vm.isShow = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c(
        "el-form",
        { attrs: { model: _vm.form, "label-width": "120px", size: "small" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "同步类型：" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.syncType,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "syncType", $$v)
                    },
                    expression: "form.syncType",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "FULL" } }, [
                    _vm._v("全量同步"),
                  ]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: "INCREMENT" } }, [
                    _vm._v("增量同步"),
                  ]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: "UPDATE" } }, [
                    _vm._v("修改同步"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.needStoreId
            ? _c(
                "el-form-item",
                { attrs: { label: "店铺：" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: "请选择店铺",
                        filterable: "",
                        remote: "",
                        "reserve-keyword": "",
                        clearable: "",
                        loading: _vm.storeLoading,
                        "remote-method": _vm.handleStoreSearch,
                      },
                      on: { focus: _vm.handleStoreFocus },
                      model: {
                        value: _vm.form.storeId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "storeId", $$v)
                        },
                        expression: "form.storeId",
                      },
                    },
                    _vm._l(_vm.storeOptions, function (item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.value, value: String(item.key) },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.handleClose } },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.handleConfirm },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }